
import { InsightCard } from '@/types/insight';
import { useEntityRealtime } from './realtime/useEntityRealtime';

/**
 * Hook to set up real-time subscription for insight card updates using Universal Real-time Manager
 * This ensures card UI updates when stats are modified by backend processes
 * 
 * @param cardId - The ID of the insight card to watch for updates
 * @param onCardUpdate - Callback function to handle card updates
 */
export const useInsightCardRealtime = (
  cardId: string | undefined,
  onCardUpdate: (updatedCard: InsightCard) => void
) => {
  const { isConnected, connectionStatus } = useEntityRealtime(
    'card',
    cardId || '',
    {
      onEntityUpdate: (updatedCard: any) => {
        console.log('Received real-time update for insight card:', updatedCard);
        
        // Transform the payload into an InsightCard object
        const transformedCard: InsightCard = {
          id: updatedCard.id,
          title: updatedCard.title,
          category: updatedCard.category,
          category_id: updatedCard.category_id,
          agreePercentage: updatedCard.agree_percentage,
          totalPollsters: updatedCard.total_pollsters,
          description: updatedCard.description,
          country_code: updatedCard.country_code,
          constituency_code: updatedCard.constituency_code,
          status: updatedCard.status as 'draft' | 'published' | 'archived',
          created_at: updatedCard.created_at,
          updated_at: updatedCard.updated_at,
          slug: updatedCard.slug
        };
        
        // Call the callback to update the parent component
        onCardUpdate(transformedCard);
        console.log('Card UI update triggered with new data:', transformedCard);
      },
      
      onError: (error) => {
        console.error('Insight card real-time error:', error);
      }
    },
    !!cardId // Only enabled if cardId is provided
  );

  return {
    isConnected,
    connectionStatus
  };
};
